import React from "react";
import { UserOutlined } from "@ant-design/icons";

const Header = ({ candidatePhoto, name, email }) => {
  const photo = candidatePhoto || null;
  return (
    <div className="profile-header rounded">
      {photo ? (
        <img src={photo} alt="Profile" />
      ) : (
        <UserOutlined style={{ fontSize: "2rem" }} />
      )}
      <div>
        <h5 className="mb-0 text-capitalize text-white">{name}</h5>
        <small>{email}</small>
      </div>
    </div>
  );
};

export default Header;
